import Persistable from './db/persistable.js';

var privateProfileMixin = {
  mixins: [
    Persistable
  ],
  data () {
    return {
      email: "",
      phoneNumber: ""
    };
  }
};

export { privateProfileMixin as default };
